import { render, staticRenderFns } from "./DcList.vue?vue&type=template&id=48552dfc&scoped=true"
import script from "./DcList.vue?vue&type=script&lang=js"
export * from "./DcList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48552dfc",
  null
  
)

export default component.exports